import React from 'react';
import {
    HashRouter,
  Switch,
  Redirect,
  Route
} from 'react-router-dom'
import {connect} from "react-redux";
import Snackbar from '@material-ui/core/Snackbar';

import MySnackbarContentWrapper from './component/utils/MySnackbarContentWrapper';
import ConfirmDialog from './component/utils/ConfirmDialog'

import * as actionCreators from "./actions/actionCreators"

/* Containers */
import Registercon from './container/auth/register-container.js';
import Logincon from './container/auth/login-container.js';
import Appcon from './container/app-container.js';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import orange from '@material-ui/core/colors/orange';

const PrivateRoute = ({component: Component, authed, ...rest}) => {
  return (
    <Route
      {...rest}
      render={(props) => rest.isLoggedIn === true
        ? <Component {...props} />
        : <Redirect to={{pathname: '/login', state: {from: props.location}}} />}
    />
  )
};

const theme = createMuiTheme({
    palette: {
        primary: blue,
        secondary: orange,
    },
});

class App extends React.Component{
    constructor(props){
      super(props);
      this.handleSnackbarClose = this.handleSnackbarClose.bind(this);
    }

    handleSnackbarClose(event, reason){
      if (reason === "clickaway") {
        return;
      }

      this.props.closeSnackbar();
    };

    componentWillMount() {
      this.props.loggedIn()
    }

    render(){
      return(
        <HashRouter history={this.props.history}>
            <MuiThemeProvider theme={theme}>
              <div className="mdl-layout__container" style={{height: "100%"}}>
                <ConfirmDialog open={this.props.openConfirmation} onCancel={this.props.closeConfirmation} onAccept={this.props.confirmationCallback} title={this.props.confirmationTitle} message={this.props.confirmationMsg} />
                <Snackbar
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                  }}
                  open={this.props.openSnackbar}
                  autoHideDuration={6000}
                  onClose={this.handleSnackbarClose}
                >
                  <MySnackbarContentWrapper
                    onClose={this.handleSnackbarClose}
                    variant={this.props.snackbarType}
                    message={this.props.snackbarMsg}
                  />
                </Snackbar>
                <Switch>
                  {(this.props.isLoggedIn!==null)?<PrivateRoute path="/(|account|audits|audits/new|invoices|invoices/new|map|parcours|reports|archives|journey)" component={Appcon} isLoggedIn={this.props.isLoggedIn} />:null}
                  <Route path="/login" component={Logincon} />
                  <Route path="/register" component={Registercon} />
                </Switch>
              </div>
            </MuiThemeProvider>
        </HashRouter>
      )
    }
}


const mapStateToProps=(state)=>{
    return state
};

export default connect (mapStateToProps, actionCreators)(App);



// WEBPACK FOOTER //
// ./src/App.js